/**
 * <ActivityCorrectionPoints> — ce que disent les pastilles de la copie corrigée (organism).
 *
 * Sous l'image de correction, un point par pastille, dans leur ordre. Sans eux, le parent voit
 * des numéros colorés sur la copie sans savoir ce qu'ils signalent. Pas de point → rien : l'image
 * seule reste lisible telle quelle (une ancienne correction, dessinée à la main par l'IA).
 */
import React from "react"

import { type UIActivityCorrectionPoint } from "../../../ports/primary/ui/types"
import { Stack } from "../../atoms/containers/Stack"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { ActivityCorrectionPoint } from "../../molecules/ActivityCorrectionPoint"

export type ActivityCorrectionPointsProps = {
    points: UIActivityCorrectionPoint[]
    testID?: string
}

export function ActivityCorrectionPoints(props: ActivityCorrectionPointsProps) {
    const { points, testID } = props
    if (points.length === 0) return null

    return (
        <Stack gap="3" testID={testID}>
            <SectionLabel>Correction</SectionLabel>
            {points.map((point) => (
                <ActivityCorrectionPoint key={point.index} point={point} />
            ))}
        </Stack>
    )
}
